import { render, staticRenderFns } from "./Marcacao.vue?vue&type=template&id=5fa8fc38&"
import script from "./Marcacao.vue?vue&type=script&lang=js&"
export * from "./Marcacao.vue?vue&type=script&lang=js&"
import style0 from "./Marcacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports